<template>
  <v-container fluid id="benefits" class="bonos-osd-container">
    <!-- Sección de Bonos -->
    <v-col cols="12" class="text-center">
      <h2 class="font-weight-bold text-primary">
        Beneficios al adquirir la OSD
      </h2>
    </v-col>

    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card class="bonos-card">
          <!-- Imagen de oferta superpuesta -->
          <v-img
            src="~@/assets/img/oferta.png"
            class="oferta-img"
            max-width="120"
          ></v-img>

          <v-list dense>
            <v-list-item v-for="(bono, index) in bonos" :key="index">
              <v-list-item-icon>
                <v-icon style="color: #9abe23">mdi-check-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="bono-text">
                  {{ bono }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <!-- Botón para mostrar detalles -->
          <v-btn
            block
            rounded
            color="#9abe23"
            class="white--text mt-4"
            @click="mostrarDetalles = !mostrarDetalles"
          >
            {{
              mostrarDetalles
                ? "Ocultar Oferta y Datos"
                : "Ver Oferta y Datos Bancarios"
            }}
          </v-btn>

          <!-- Sección desplegable -->
          <v-expand-transition>
            <v-card v-if="mostrarDetalles" class="detalles-card mt-4">
              <v-card-text>
                <h3 class="text-center font-weight-bold">🎁 Oferta Especial</h3>
                <p class="detalles-text text-center">
                  ¡Aprovecha nuestra promoción exclusiva por tiempo limitado!
                </p>

                <v-divider class="my-3"></v-divider>

                <v-divider class="my-3"></v-divider>

                <h3 class="text-center font-weight-bold">
                  💰 Precio Promocional
                </h3>
                <p class="precio-oferta text-center">
                  <s style="color: red; font-weight: bold">Antes: $4,500</s>
                  <br />
                  <strong style="color: green; font-size: 1.3rem">
                    Ahora: $3,500 🔥 ¡Sólo por este mes!
                  </strong>
                </p>

                <v-divider class="my-3"></v-divider>

                <h3 class="text-center font-weight-bold">💳 Datos Bancarios</h3>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-bank</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Banco: Scotiabank</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-card-account-details</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Cuenta: 25600513288</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-numeric</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >CLABE: 044470256005132889</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        >Titular: Moisés Zizumbo Ramos</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider class="my-3"></v-divider>

                <!-- Nota para compartir la captura -->
                <div class="text-center captura-text">
                  📸
                  <strong
                    >¡No olvides compartir tu captura de transferencia!</strong
                  >
                  Envíala por WhatsApp para confirmar tu pago y activar tu
                  cuenta.
                </div>

                <v-btn
                  block
                  rounded
                  color="#9abe23"
                  class="white--text mt-4"
                  :href="'https://wa.me/+5214434846542?text=Hola,%20aquí%20está%20mi%20comprobante%20de%20pago%20para%20OSD.'"
                  target="_blank"
                >
                  📩 Enviar por WhatsApp
                </v-btn>
              </v-card-text>
            </v-card>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>

    <!-- Sección de Garantía (Opcional) -->
    <v-col v-if="garantia" cols="12" class="text-center">
      <v-card class="garantia-card">
        <v-card-title class="font-weight-bold">
          🔒 Garantía de Satisfacción
        </v-card-title>
        <v-card-text class="garantia-text">
          {{ garantia }}
        </v-card-text>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      mostrarDetalles: false, // Estado para mostrar/ocultar la oferta y los datos bancarios
    };
  },
  props: {
    bonos: {
      type: Array,
      required: true,
    },
    garantia: {
      type: String,
      default: "", // No se muestra si está vacío
    },
  },
};
</script>

<style scoped>
.bonos-osd-container {
  padding: 2rem 0;
  width: 80%;
}

.bonos-card {
  position: relative; /* Para posicionar la imagen de oferta */
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

.bono-text {
  font-size: 1.1rem;
  color: #555;
}

.garantia-card {
  background: #f3f3f3;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-top: 1.5rem;
}

.garantia-text {
  font-size: 1rem;
  color: #333;
}

.oferta-img {
  position: absolute;
  top: -30px;
  right: -20px;
  width: 120px;
  z-index: 2;
}

.detalles-card {
  background: #eaf5d3;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.detalles-text {
  font-size: 1.1rem;
  color: #444;
}

.captura-text {
  font-size: 1rem;
  color: #333;
  margin-top: 10px;
}

@media (max-width: 480px) {
  .oferta-img {
    top: -10px;
    right: -5px;
    width: 80px;
  }
}
</style>
